export default function Security() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      text: 'Tu inversión puede estar respaldada por jurisdicciones estables y reguladas internacionalmente.'
    },
    {
      icon: 'ri-file-shield-line',
      text: 'Protección legal y ventajas fiscales según el país desde donde inviertas.'
    },
    {
      icon: 'ri-earth-line',
      text: 'Reducción del riesgo país al invertir fuera de economías frágiles.'
    },
    {
      icon: 'ri-eye-line',
      text: 'Transparencia absoluta en aportes y movimientos.'
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-[#0A1A35]">
      <div className="max-w-6xl mx-auto">
        {/* Título */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Estructuras internacionales,{' '}
            <span className="text-[#D4AF37]">regulación y seguridad</span>
          </h2>
        </div>

        {/* Grid de características */}
        <div className="grid md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-black/40 p-6 rounded-xl border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#D4AF37]/10 rounded-lg flex-shrink-0">
                <i className={`${feature.icon} text-2xl text-[#D4AF37]`}></i>
              </div>
              <p className="text-[#C5C7D0] leading-relaxed pt-2">
                {feature.text}
              </p>
            </div>
          ))}
        </div>

        {/* Nota adicional */}
        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-[#D4AF37]/10 to-[#A87E10]/10 px-8 py-4 rounded-full border border-[#D4AF37]/30">
            <p className="text-[#D4AF37] font-semibold">
              <i className="ri-lock-line mr-2"></i>
              Seguridad y confianza en cada inversión
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
